import { Injectable } from "@angular/core";
import { global } from "../global";
import { BehaviorSubject, Observable, catchError, of, throwError } from "rxjs";
import { companiaLista } from "../interface/CompaniaListaInterface";

@Injectable({
    providedIn: 'root',
})

export class listasServices {
    private listasCompania = new BehaviorSubject<companiaLista[]>([]);
    private listasEditarCompania = new BehaviorSubject<companiaLista[]>([]);
    private listasEliminarCompania = new BehaviorSubject<companiaLista[]>([]);

    vallistasCompania$ = this.listasCompania.asObservable();
    vallistasEliminarCompania$ = this.listasEliminarCompania.asObservable();
    vallistasEditarCompania$ = this.listasEditarCompania.asObservable();
    updatelistasCompania (data: any){
        this.listasCompania.next(data);
    }

    updatelistasEliminarCompania (data: any){
        this.listasEliminarCompania.next(data);
    }
    updatelistasEditarCompania (data: any){
        this.listasEditarCompania.next(data);
    }

    addlistasEliminarCompania (data: any) {
        // Emitir un array nuevo (no mutar el valor actual del BehaviorSubject): los
        // datasources que consumen este stream comparan por referencia para re-renderizar.
        const currentList = this.listasEliminarCompania.getValue();
        this.listasEliminarCompania.next([...currentList, ...(data ?? [])]);
    }
    addlistasEditarCompania (data: any) {
        // Emitir un array nuevo (no mutar el valor actual del BehaviorSubject); si se muta
        // in situ, el CdkTableVirtualScrollDataSource de editar-lista recibe la misma
        // referencia y no re-renderiza al añadir compañías.
        const currentList = this.listasEditarCompania.getValue();
        // Evitar duplicados por idNectum (el guardado hace DELETE + INSERT por idnectum).
        const existentes = new Set(currentList.map((c: any) => c.idNectum));
        const nuevos = (data ?? []).filter((c: any) => !existentes.has(c.idNectum));
        this.listasEditarCompania.next([...currentList, ...nuevos]);
    }
}